<template>
  <pl-dialog
    :title="'Book Virtual Classroom Visit'"
    :size="'xl'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <body class="px-7 overflow-auto">
      <div class="my-7 flex justify-center font-semibold text-base">
        Request a virtual classroom visit and have a Parlay Instructional
        Strategist facilitate a RoundTable with your class.
      </div>
      <div id="hubspotForm" v-once></div>
    </body>
  </pl-dialog>
</template>
<script>
  export default {
    mounted() {
      const script = document.createElement('script');
      script.charset = 'utf-8';
      script.type = 'text/javascript';
      script.src = '//js.hsforms.net/forms/v2.js';
      (document.body || document.head).appendChild(script);

      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: 'na1',
            portalId: '2529635',
            formId: '97efbcbc-3790-4794-b0f2-3840194b9245',
            target: '#hubspotForm',
          });
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// virtualClassVisitModal.vue?c4a90d7e